import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CategoryInfo } from '@reflact/ipkv-types';
import { ButtonModule } from "primeng/button";
import { StepperModule } from 'primeng/stepper';
import { Api } from '../api';

@Component({
  standalone: true,
  imports: [ButtonModule, StepperModule],
  templateUrl: './introduction.component.html',
  styleUrl: './introduction.component.scss'
})
export class IntroductionComponent {
  public api = inject(Api);
  public router = inject(Router);

  protected get introductions(): { title: string; content: string }[] {
    const categoryInfo = this.api.fallaufgabe?.categoryInfo as (CategoryInfo & {
      vcIntroductions?: { title: string; content: string }[];
    }) | undefined;

    if (this.api.fallaufgabe?.type === 'vc') {
      return categoryInfo?.vcIntroductions ?? [];
    }

    return categoryInfo?.fallAufgabeIntroductions ?? [];
  }

  protected isLastStep(index: number): boolean {
    return index === this.introductions.length - 1;
  }

  protected hasIntroductions(): boolean {
    return this.introductions.length > 0;
  }

  public async start() {
    await this.api.start();
    this.router.navigate(["/lernbegleiter"]);
  }

  protected zahlZuWort(n: number): string {
    const einheiten = ["null", "eine", "zwei", "drei", "vier", "fünf", "sechs", "sieben", "acht", "neun"];
    const zehner = ["", "zehn", "zwanzig", "dreißig", "vierzig", "fünfzig", "sechzig", "siebzig", "achtzig", "neunzig"];
    const sonder: Record<number, string> = {
      11: "elf",
      12: "zwölf",
      16: "sechzehn",
      17: "siebzehn"
    };

    if (sonder[n]) return sonder[n];
    if (n < 10) return einheiten[n];
    if (n < 20) return einheiten[n - 10] + "zehn";
    if (n < 100) {
      const e = n % 10;
      const z = Math.floor(n / 10);
      return e === 0 ? zehner[z] : `${einheiten[e]}und${zehner[z]}`;
    }
    if (n < 1000) {
      const h = Math.floor(n / 100);
      const rest = n % 100;
      return (h === 1 ? "einhundert" : einheiten[h] + "hundert") + (rest ? this.zahlZuWort(rest) : "");
    }
    return n.toString(); // fallback
  }

  protected minutenZuText(minuten: number): string {
    const stunden = Math.floor(minuten / 60);
    const restMinuten = minuten % 60;

    if (stunden > 0 && restMinuten > 0) {
      return `${this.zahlZuWort(stunden)} ${stunden === 1 ? "Stunde" : "Stunden"} und ${this.zahlZuWort(restMinuten)} ${restMinuten === 1 ? "Minute" : "Minuten"}`;
    } else if (stunden > 0) {
      return `${this.zahlZuWort(stunden)} ${stunden === 1 ? "Stunde" : "Stunden"}`;
    } else {
      return `${this.zahlZuWort(restMinuten)} ${restMinuten === 1 ? "Minute" : "Minuten"}`;
    }
  }
}